__turbopack_context__.v({
  "button": "SegmentedControl-module__hd3EsG__button",
  "cluster": "SegmentedControl-module__hd3EsG__cluster",
  "container": "SegmentedControl-module__hd3EsG__container",
  "group": "SegmentedControl-module__hd3EsG__group",
  "hiddenInput": "SegmentedControl-module__hd3EsG__hiddenInput",
  "shouldWrap": "SegmentedControl-module__hd3EsG__shouldWrap",
  "stack": "SegmentedControl-module__hd3EsG__stack",
});
